/**
 * Heurística para render dual de contenido: las noticias/T&C antiguas se guardaron como HTML
 * (CKEditor); las nuevas se escriben en Markdown (ContentEditor). Si el string parece HTML lo
 * renderizamos como HTML; si no, como Markdown.
 */
export const looksLikeHtml = (value) => {
  if (typeof value !== 'string' || !value) return false;
  // Detecta etiquetas de bloque típicas de CKEditor.
  return /<\/?(p|div|h[1-6]|ul|ol|li|br|strong|em|img|a|figure|table|blockquote)\b/i.test(value);
};

export default { looksLikeHtml };
